import { Checkbox, CheckboxProps } from "semantic-ui-react";

export type BPCheckboxProps = CheckboxProps & {

};

export function BPCheckbox(props: BPCheckboxProps) {
    return <Checkbox {...props}>{props.children}</Checkbox>
}